// material-ui
import { Box, Button, Card, Checkbox, ClickAwayListener, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material';
import Popper from '@mui/material/Popper';
import { useIntl } from 'react-intl';
import { SearchPopProps } from './types';

const SearchPopOptions = ({ valueIsNumber, handelFilter, handleSearch, searchFields, show, setOpen, anchorEl, id }: SearchPopProps) => {
    const intl = useIntl();

    return (
        <Popper sx={{ zIndex: 10000 }} open={show} anchorEl={anchorEl || null} id={id} placement="bottom-end">
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box
                    component={Card}
                    elevation={2}
                    sx={{
                        minWidth: 200,
                        p: 1,
                        paddingRight: 2,
                        borderRadius: 2,
                        paddingTop: 3
                    }}
                >
                    <FormControl>
                        <Typography variant="h6" id="radio-filter-type">
                            Filter Types
                        </Typography>
                        <FormGroup aria-labelledby="radio-filter-type">
                            <FormControlLabel
                                control={
                                    <Checkbox checked={searchFields.includes('productName')} onChange={handelFilter} name="productName" />
                                }
                                label={intl.formatMessage({ id: 'product_name' })}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchFields.includes('idProd')}
                                        onChange={handelFilter}
                                        name="idProd"
                                        disabled={!valueIsNumber}
                                    />
                                }
                                label={intl.formatMessage({ id: 'product_id' })}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchFields.includes('idSKU')}
                                        onChange={handelFilter}
                                        name="idSKU"
                                        disabled={!valueIsNumber}
                                    />
                                }
                                label={intl.formatMessage({ id: 'sku' })}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox checked={searchFields.includes('productRefID')} onChange={handelFilter} name="productRefID" />
                                }
                                label={intl.formatMessage({ id: 'reference_code' })}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchFields.includes('ean')}
                                        onChange={handelFilter}
                                        name="ean"
                                        disabled={!valueIsNumber}
                                    />
                                }
                                label="EAN"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={searchFields.includes('textLink')} onChange={handelFilter} name="textLink" />}
                                label={intl.formatMessage({ id: 'product_url' })}
                            />
                            <FormControlLabel
                                control={<Checkbox checked={searchFields.includes('refID')} onChange={handelFilter} name="refID" />}
                                label={intl.formatMessage({ id: 'sku_reference_code' })}
                            />
                        </FormGroup>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                handleSearch();
                                setOpen(false);
                            }}
                        >
                            {intl.formatMessage({ id: 'save' })}
                        </Button>
                    </FormControl>
                </Box>
            </ClickAwayListener>
        </Popper>
    );
};

export default SearchPopOptions;
